"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipientString = exports.getAddressFromPublicKey = exports.openCryptobox = exports.sealCryptobox = exports.decryptCryptoboxPayload = exports.encryptCryptoboxPayload = exports.getKeypairFromSeed = exports.getHexHash = exports.toHex = void 0;
const bs58check = require("bs58check");
const sodium = require("libsodium-wrappers");
/* eslint-disable prefer-arrow/prefer-arrow-functions */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toHex(value) {
    return Buffer.from(value).toString('hex');
}
exports.toHex = toHex;
async function getHexHash(key) {
    await sodium.ready;
    return toHex(sodium.crypto_generichash(32, key));
}
exports.getHexHash = getHexHash;
async function getKeypairFromSeed(seed) {
    await sodium.ready;
    return sodium.crypto_sign_seed_keypair(sodium.crypto_generichash(32, sodium.from_string(seed)));
}
exports.getKeypairFromSeed = getKeypairFromSeed;
async function encryptCryptoboxPayload(message, sharedKey) {
    await sodium.ready;
    const nonce = Buffer.from(sodium.randombytes_buf(sodium.crypto_secretbox_NONCEBYTES));
    const combinedPayload = Buffer.concat([
        nonce,
        Buffer.from(sodium.crypto_secretbox_easy(Buffer.from(message, 'utf8'), nonce, sharedKey))
    ]);
    return toHex(combinedPayload);
}
exports.encryptCryptoboxPayload = encryptCryptoboxPayload;
async function decryptCryptoboxPayload(payload, sharedKey) {
    await sodium.ready;
    const nonce = payload.slice(0, sodium.crypto_secretbox_NONCEBYTES);
    const ciphertext = payload.slice(sodium.crypto_secretbox_NONCEBYTES);
    return Buffer.from(sodium.crypto_secretbox_open_easy(ciphertext, nonce, sharedKey)).toString('utf8');
}
exports.decryptCryptoboxPayload = decryptCryptoboxPayload;
async function sealCryptobox(payload, publicKey) {
    await sodium.ready;
    const kxSelfPublicKey = sodium.crypto_sign_ed25519_pk_to_curve25519(Buffer.from(publicKey)); // Secret bytes to scalar bytes
    const encryptedMessage = sodium.crypto_box_seal(payload, kxSelfPublicKey);
    return toHex(encryptedMessage);
}
exports.sealCryptobox = sealCryptobox;
async function openCryptobox(encryptedPayload, publicKey, privateKey) {
    await sodium.ready;
    const kxSelfPrivateKey = sodium.crypto_sign_ed25519_sk_to_curve25519(Buffer.from(privateKey)); // Secret bytes to scalar bytes
    const kxSelfPublicKey = sodium.crypto_sign_ed25519_pk_to_curve25519(Buffer.from(publicKey)); // Secret bytes to scalar bytes
    const decryptedMessage = sodium.crypto_box_seal_open(encryptedPayload, kxSelfPublicKey, kxSelfPrivateKey);
    return Buffer.from(decryptedMessage).toString();
}
exports.openCryptobox = openCryptobox;
async function getAddressFromPublicKey(publicKey) {
    await sodium.ready;
    let plainPublicKey;
    if (publicKey.length === 64) {
        plainPublicKey = publicKey;
    }
    else if (publicKey.startsWith('edpk') && publicKey.length === 54) {
        const edpkPrefixLength = 4;
        const decoded = bs58check.decode(publicKey);
        plainPublicKey = decoded.slice(edpkPrefixLength, decoded.length).toString('hex');
    }
    else {
        throw new Error(`invalid publicKey: ${publicKey}`);
    }
    const payload = sodium.crypto_generichash(20, Buffer.from(plainPublicKey, 'hex'));
    const tz1Prefix = Buffer.from(new Uint8Array([6, 161, 159]));
    return bs58check.encode(Buffer.concat([tz1Prefix, Buffer.from(payload)]));
}
exports.getAddressFromPublicKey = getAddressFromPublicKey;
function recipientString(recipientHash, relayServer) {
    return `@${recipientHash}:${relayServer}`;
}
exports.recipientString = recipientString;
/* eslint-enable prefer-arrow/prefer-arrow-functions */
//# sourceMappingURL=crypto.js.map